import { SortTag } from '@dealstack/frontend/shared/components/SortTag/SortTag.tsx';
import { SecurityRankFieldStyles } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityRankField/SecurityRankField.styles.tsx';
import { Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	rankName?: string;
	sortOrder?: number;
	// Total number of rank tiers for the issuer, for the "of N" frame of reference.
	totalRanks?: number;
	// Empty state: security has no rank for this dimension yet.
	unranked?: boolean;
	showContainer?: boolean;
	onClick?: () => void;
}

export const SecurityRankField = ({
	rankName,
	sortOrder,
	totalRanks,
	unranked = false,
	showContainer = true,
	onClick,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<SecurityRankFieldStyles
			className={`${showContainer ? 'container' : ''} ${onClick ? 'clickable' : ''}`}
			onClick={onClick}
			role={onClick ? 'button' : undefined}
			tabIndex={onClick ? 0 : undefined}
			onKeyDown={(e) => {
				if (onClick && (e.key === 'Enter' || e.key === ' ')) {
					e.preventDefault();
					onClick();
				}
			}}
		>
			{unranked ? (
				<Text fz={showContainer ? 14 : 18} c="dark.3" className="rank-name">
					{tCapManage('securities.rank.unranked', { defaultValue: 'Unranked' })}
				</Text>
			) : (
				<>
					<SortTag label={sortOrder ?? 1} />

					{!!totalRanks && (
						<Text fz="sm" c="dark.4" className="rank-total">
							{tCapManage('securities.rank.of', {
								total: totalRanks,
								defaultValue: 'of {{total}}',
							})}
						</Text>
					)}

					<Text fz={showContainer ? 14 : 18} className="rank-name">
						{rankName}
					</Text>
				</>
			)}

			{onClick && (
				<span className="cta">
					<Text fz="sm" c="blue.6" className="cta-label">
						{unranked
							? tCapManage('securities.rank.set_rank', { defaultValue: 'Set rank' })
							: tCapManage('securities.rank.manage', { defaultValue: 'Manage' })}
					</Text>
					<Icon variant="arrow-right" size="lg" className="arrow" />
				</span>
			)}
		</SecurityRankFieldStyles>
	);
};
